<script>
import { useResourcesStore } from "../../stores/resources";
export default {
  setup() {
    const resourcesStore = useResourcesStore();
    return { resourcesStore };
  },
  computed: {
    infos() {
      return [
        {
          label: "views.admin.dashboard.number_of_user",
          link: "/admin/user-validation",
          count: this.waitingCount,
        },
        {
          label: "views.admin.dashboard.number_of_municipalities",
          link: "/admin/commune-list",
          count: this.communesCount,
        },
        {
          label: "views.admin.dashboard.number_of_imported_files",
          link: "/admin/imported-data",
          count: this.importCount,
        },
      ];
    },

    waitingCount() {
      return this.count("waiting");
    },

    communesCount() {
      return this.count("towns");
    },

    importCount() {
      return this.count("imports");
    },
  },
  mounted() {
    this.resourcesStore.refresh({ type: "waiting" });
    this.resourcesStore.refresh({ type: "towns" });
    this.resourcesStore.refresh({ type: "imports" });
  },
  methods: {
    count(resource) {
      return this.resourcesStore[resource].elements.total;
    },
  },
};
</script>

<template>
  <div>
    <div v-for="info in infos" :key="info.label" class="py-1 text-gray-700">
      <span>{{ $t(info.label) }}:</span>
      <b v-if="info.count !== null">{{ info.count }}</b>
      <font-awesome-icon v-else icon="spinner" spin />
      <router-link class="text-airbnbBlue" :to="info.link">
        {{ $t("views.admin.dashboard.more") }}
      </router-link>
    </div>
  </div>
</template>
